class FooterModal {
    constructor() {
        this.modalOverlay = document.getElementById('FooterModalOverlay');
        this.modalContent =  document.getElementById('FooterModalContent');
        this.modalClose = document.getElementById('FooterModalClose');
        this.modalLoader = document.getElementById('FooterModalLoader');
        this.modalContainer = document.querySelector('.footer-modal-container');
        this.modalBackdrop = document.querySelector('.footer-modal-overlay__backdrop');

        if (!this.modalOverlay || ! this.modalContent || !this.modalClose) return;

        this.cache = {};
        this.hoverTimer = null;
        this.currentUrl = null;
        this.activeTrigger = null;

        this.noContentMsg = this.modalContent.dataset.noContentMessage || 'No content found on this page';
        this.errorMsg = this.modalContent.dataset.errorMessage || 'Unable to load content. Please try again.';
        this.handleKeydown = this.handleKeydown.bind(this);

        this.bindEvents();
    }

    bindEvents() {
        const links = document.querySelectorAll('.js-footer-modal-link');

        links.forEach(link => {
            link.addEventListener('mouseenter', (e) => {
                if (window.matchMedia('(min-width: 750px)').matches) {
                    this.hoverTimer = setTimeout(() => {
                        const url = link.href;
                        if (!url || !url.startsWith(window.location.origin)) return;
                        if (url.includes('/store') || url.includes('/stores')) return;
                        this.activeTrigger = link;
                        this.open(url);
                    }, 300);
                }
            });

            link.addEventListener('mouseleave', () => {
                if (this.hoverTimer) clearTimeout(this.hoverTimer);
            });

            link.addEventListener('click', (e) => {
                // e.preventDefault();
                const url = link.href;
                if (!url || !url.startsWith(window.location.origin)) return;
                if (url.includes('/store') || url.includes('/stores')) return;
                
                e.preventDefault();
                this.activeTrigger = link;
                this.open(url);
            });
        });

        if (this.modalClose) {
            this.modalClose.addEventListener('click', () => this.close());
        }

        this.modalOverlay.addEventListener('click', (e) => {
            if (e.target === this.modalOverlay || e.target === this.modalBackdrop) {
                this.close();
            }
        });

        if (this.modalContainer) {
            let touchStartY = 0;
            this.modalContainer.addEventListener('touchstart', (e) => {
                touchStartY = e.changedTouches[0].screenY;
            }, { passive: true });
            
            this.modalContainer.addEventListener('touchmove', (e) => {
                if (window.innerWidth < 750) {
                    const touchMoveY = e.changedTouches[0].screenY;
                    
                    if (touchMoveY - touchStartY > 80 && this.modalContent.scrollTop <= 0) {
                        this.close();
                    }
                }
            }, { passive: true });
        }

        document.addEventListener('keydown', this.handleKeydown);
    }

    handleKeydown(e) {
        if (!this.modalOverlay.classList.contains('is-active')) return;

        if (e.key === 'Escape') {
            this.close();
            return;
        }

        //Trap focus inside modal
        if (e.key === 'Tab') {
            const focusable = this.modalOverlay.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }

    async open(url) {
        if (!url) return;
        if (this.modalOverlay.classList.contains('is-active') && this.currentUrl === url) return;
        this.currentUrl = url;

        this.modalOverlay.classList.add('is-active');
        this.modalOverlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('footer-modal-open');

        this.modalClose.focus();

        this.modalContent.classList.add('is-loading');
        if (this.modalLoader) this.modalLoader.classList.remove('hidden');

        if (this.cache[url]) {
            this.renderContent(this.cache[url]);
            return;
        }

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');            

            const htmlText = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const mainContentElement = doc.querySelector('#MainContent') || doc.querySelector('main');
            if (mainContentElement) {
                this.cache[url] = mainContentElement.innerHTML;
                this.renderContent(mainContentElement.innerHTML);
            } else {
                this.renderErrorContent(this.noContentMsg);
            }

        } catch (error) {
            console.error('Error fetching modal content:', error);
            this.renderErrorContent(this.errorMsg);
        }
    }

    renderContent(html) {
        this.modalContent.innerHTML = html;
        this.modalContent.classList.remove('is-loading');

        if (this.modalLoader) {
            this.modalLoader.classList.add('hidden');
            this.modalLoader.style.display = 'none';
        }
    }

    renderErrorContent(message) {
        this.modalContent.textContent = message;
        this.modalContent.classList.remove('is-loading');

        if (this.modalLoader) {
            this.modalLoader.classList.add('hidden');
            this.modalLoader.style.display = 'none';
        }
    }

    close() {
        this.modalOverlay.classList.remove('is-active');
        this.modalOverlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('footer-modal-open');
        this.currentUrl = null;
        if (this.hoverTimer) clearTimeout(this.hoverTimer);

        if (this.activeTrigger) {
            this.activeTrigger.focus();
            this.activeTrigger = null;
        }

        setTimeout(() => {
            this.modalContent.innerHTML = '';
            this.modalContent.classList.add('is-loading');
            if (this.modalLoader) this.modalLoader.style.display = '';
        }, 300);
            
    }
}

// Initialize when Dom is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new FooterModal());
} else {
    new FooterModal();
}